// extracted by mini-css-extract-plugin
export var wrapper = "Description-module--wrapper--3zdJK";
export var content = "Description-module--content--3MXYN";